import React from "react";
import { SettingsForm } from "src/page-components/cabinet/settings/SettingsForm";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const Settings = () => (
  <MetadataWrapper name="settings">
    <SettingsForm />
  </MetadataWrapper>
);
export default Settings;
